<template>
  <div class="md my-3">
    <div class="row my-2 py-2 mx-2 justify-content-center">
      <h1 class="text-center">Developer Badges</h1>
      <p>
        Developer Badges is an employee rewards tool.
        Provide recognition for achievements and behaviour in your organisation by awarding badges to your employees.
      </p>
      <p>
        Badges are not monetary, nor do they make someone better than someone else.
        The only intention of the badges is to provide permanent and visible recognition for <i>exceptional</i> performance, next to the usual monetary rewards or a promotion.
      </p>
      <p>
        Check out this blog post for a <a href="https://www.vangemert.dev/blog/badges-for-software-developers">list of available badges</a>.
        Why would your company need this?
        Read my blog post about "<a href="https://www.vangemert.dev/blog/the-motivation-paradox">The motivation paradox</a>."
      </p>
      <div class="btn-group d-flex w-100">
        <div class="mb-2 mt-0 w-100">
          <router-link to='/badges'>
            <button type="button"
                    class="btn btn-outline-light w-100">
              View my badges
            </button>
          </router-link>
        </div>
      </div>
      <div class="btn-group d-flex w-100">
        <div class="mb-3 mt-0 w-100">
          <router-link to='/badges/award'>
            <button type="button"
                    class="btn btn-outline-light w-100">
              Award badges to employees for free
            </button>
          </router-link>
        </div>
      </div>
      <h2>Example</h2>
      <span class="my-2 mb-3 text-center email-title">
        <i>name@example.com</i>
      </span>
      <div class="row mt-0 px-2 mx-2 pb-4">
        <table>
          <tbody>
            <tr>
              <td class="text-center">
                <span class="icon">
                  {{demo_badge.icon}}
                </span>
              </td>
              <td>
                <span class="badge-title">
                  <b>{{demo_badge.title}}</b>
                </span>
              </td>
              <td>
                <i>{{demo_badge.description}}</i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import { badges } from '@/badges/badges.js'

  export default {
    data() {
      return {
        demo_badge: badges[Math.floor(Math.random() * badges.length)],
        interval: setInterval(() => {
          this.new_badge()
        }, 3000)
      }
    },
    created () {
      document.title = "Developer Badges"
    },
    methods: {
      new_badge() {
        this.demo_badge = badges[Math.floor(Math.random() * badges.length)]
      }
    },
    unmounted() {
      clearInterval(this.interval);
    }
  }
</script>

<style scoped>
  .md {
    text-align: left;
    background-color: rgb(43, 43, 43);
    border-radius: 10px;
  }
  .title {
    font-family: "Courier New", Courier, monospace;
  }
  img {
    width: 100%;
  }
  .email-title {
    font-size: 25px;
    word-break: break-all;
  }

  .badge-title {
    font-size: 18px;
  }

  .icon {
    font-size: 60px;
  }

  table, th, td {
    color: #fff;
    border-collapse: collapse;
  }

  tr {
    background-color: rgb(43, 43, 43) !important;
  }
</style>